export const CloseIconStyle = { fontSize: "14px", color: "#315eac" };

export const DropdownLabelStyle = { marginTop: "-6px" };

export const SelectStyle = {
  width: "100%",
};

export const FormControlStyle = { width: "100%" };

export const ApplyButtonStyle = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  color: "#01579B",
  cursor: "pointer",
};

export const ApplyButtonWrapper = {
  textAlign: "right",
  paddingTop: "10px",
  marginBottom: "-10px",
};

export const closeButtonStyle = {
  position: "absolute",
  top: 5,
  right: 5,
};

export const ModalContentStyle = {
  position: "absolute" as "absolute",
  top: "20%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  outline: "none",
  borderRadius: "10px",
};
